import { render, staticRenderFns } from "./CustomersCalendar.vue?vue&type=template&id=105c564d"
import script from "./CustomersCalendar.vue?vue&type=script&lang=js"
export * from "./CustomersCalendar.vue?vue&type=script&lang=js"
import style0 from "./CustomersCalendar.vue?vue&type=style&index=0&id=105c564d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports